/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOGenerateBankTransferDTO } from '../models/ApiResponseDTOGenerateBankTransferDTO';
import type { ApiResponseDTOGenerateDTO } from '../models/ApiResponseDTOGenerateDTO';
import type { UssdBankRecord } from '../models/UssdBankRecord';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GenerateApiService {

    /**
     * Get Generate - Bank Transfer
     * Generate new operation code
     * @param operationId 
     * @returns ApiResponseDTOGenerateBankTransferDTO OK
     * @throws ApiError
     */
    public static getGenerateInBankTransfer(
operationId: string,
): CancelablePromise<ApiResponseDTOGenerateBankTransferDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/generate/{operationId}/in-bank-transfer',
            path: {
                'operationId': operationId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Get Generate - QrCode
     * Generate new operation code
     * @param operationId 
     * @returns ApiResponseDTOGenerateDTO OK
     * @throws ApiError
     */
    public static getGenerateQrCode(
operationId: string,
): CancelablePromise<ApiResponseDTOGenerateDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/generate/{operationId}/qrcode',
            path: {
                'operationId': operationId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Put Generate - USSD
     * Generate new operation code
     * @param operationId 
     * @param requestBody 
     * @returns ApiResponseDTOGenerateDTO OK
     * @throws ApiError
     */
    public static putGenerateUssd(
operationId: string,
requestBody: UssdBankRecord,
): CancelablePromise<ApiResponseDTOGenerateDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/generate/{operationId}/ussd',
            path: {
                'operationId': operationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

}
